(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lux-home-promo-price"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.luxSharedCardPrices) return;
  window.luxSharedCardPrices = true;
  const query = 'mutation CardQuote($variant: ID!, $country: CountryCode!) @inContext(country: $country) { cartCreate(input: {buyerIdentity: {countryCode: $country}, lines: [{merchandiseId: $variant, quantity: 1}]}) { cart { lines(first: 1) { nodes { cost { amountPerQuantity { amount currencyCode } totalAmount { amount currencyCode } } } } } userErrors { message } } }';
  const pending = new Map();
  const queue = [];
  let active = 0;
  function drain() {
    while (active < 2 && queue.length) {
      active++;
      const job = queue.shift();
      job.run().then(job.resolve, job.reject).finally(() => { active--; drain(); });
    }
  }
  function quote(variant, country, currency) {
    const key = [country, currency, variant].join(':');
    if (!pending.has(key)) pending.set(key, new Promise((resolve, reject) => {
      queue.push({resolve, reject, run: async () => {
        for (let attempt = 0; attempt < 2; attempt++) {
          try {
            const response = await fetch('/api/2026-10/graphql.json', {
              method: 'POST', headers: {'Content-Type': 'application/json'},
              signal: AbortSignal.timeout(15000),
              body: JSON.stringify({query, variables: {variant: 'gid://shopify/ProductVariant/' + variant, country}})
            });
            if (!response.ok) throw new Error('Card quote request failed');
            const result = await response.json();
            const payload = result.data && result.data.cartCreate;
            const line = payload && payload.cart && payload.cart.lines.nodes[0];
            if (result.errors || !line || payload.userErrors.length) throw new Error('Card quote unavailable');
            return line.cost;
          } catch (error) {
            if (attempt === 1) throw error;
          }
        }
      }});
      drain();
    }).catch(error => { pending.delete(key); throw error; }));
    return pending.get(key);
  }
  function format(cents, block) {
    const sample = block.dataset.moneySample;
    const match = sample.match(/[0-9][0-9.,'’\s\u00a0\u202f]*[0-9]/);
    if (match) {
      const n = match[0];
      const decimal = /([.,])\d{2}$/.exec(n);
      let locale = decimal && decimal[1] === ',' ? 'de-DE' : 'en-US';
      if (/['’]/.test(n)) locale = 'de-CH';
      else if (/[\s\u00a0\u202f]/.test(n)) locale = 'fr-FR';
      else if (!decimal && n.includes('.')) locale = 'de-DE';
      const digits = decimal ? 2 : 0;
      return sample.replace(n, new Intl.NumberFormat(locale, {minimumFractionDigits: digits, maximumFractionDigits: digits}).format(cents / 100));
    }
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {style: 'currency', currency: block.dataset.currency}).format(cents / 100);
  }
  function renderPrices(block, original, sale) {
    const sameDisplay = Number(block.dataset.renderedOriginal) === original && Number(block.dataset.renderedSale) === sale && block.dataset.renderedCountry === block.dataset.country && block.dataset.renderedCurrency === block.dataset.currency;
    if (sameDisplay) return;
    const saving = Math.max(0, original - sale);
    const old = block.querySelector('.lux-card-price__original');
    old.hidden = saving === 0;
    old.querySelector('[data-card-original]').textContent = format(original, block);
    block.querySelector('[data-card-current]').textContent = format(sale, block);
    const savings = block.querySelector('.lux-card-price__saving');
    if (savings) {
      savings.hidden = saving === 0;
      block.querySelector('[data-card-saving]').textContent = block.querySelector('[data-card-saving-template]').content.textContent.replace('__AMOUNT__', format(saving, block));
      block.querySelector('[data-card-percent]').textContent = block.querySelector('[data-card-percent-template]').content.textContent.replace('__PERCENT__', original > 0 ? Math.round(saving * 100 / original) : 0);
    }
    block.dataset.renderedOriginal = original;
    block.dataset.renderedSale = sale;
    block.dataset.renderedCountry = block.dataset.country;
    block.dataset.renderedCurrency = block.dataset.currency;
  }
  async function update(block, force = false) {
    if (!block.dataset.variantId) return;
    const context = [block.dataset.country, block.dataset.currency, block.dataset.variantId, block.dataset.compare].join(':');
    if (!force && block.dataset.quoteContext === context) return;
    block.dataset.quoteContext = context;
    block.dataset.quoteState = 'loading';
    try {
      const cost = await quote(block.dataset.variantId, block.dataset.country, block.dataset.currency);
      if (!block.isConnected || block.dataset.quoteContext !== context) return;
      if (cost.totalAmount.currencyCode !== block.dataset.currency || cost.amountPerQuantity.currencyCode !== block.dataset.currency) throw new Error('Card quote currency mismatch');
      const base = Math.round(Number(cost.amountPerQuantity.amount) * 100);
      const sale = Math.round(Number(cost.totalAmount.amount) * 100);
      const original = Math.max(base, Number(block.dataset.compare));
      if (!Number.isFinite(original) || !Number.isFinite(sale) || sale < 0) throw new Error('Invalid card quote');
      renderPrices(block, original, sale);
      block.dataset.quoteState = 'ready';
    } catch (error) {
      if (block.dataset.quoteContext === context) block.dataset.quoteState = 'unavailable';
    }
  }
  function scan(root) {
    if (root.matches && root.matches('[data-card-price]')) update(root);
    root.querySelectorAll('[data-card-price]').forEach(block => update(block));
  }
  document.addEventListener('luxster:variant-change', event => {
    if (!event.target.querySelectorAll) return;
    const variant = event.detail && event.detail.variant;
    event.target.querySelectorAll('.lux-detail-price').forEach(block => {
      if (!variant) {
        block.hidden = true;
        delete block.dataset.variantId;
        delete block.dataset.quoteContext;
        delete block.dataset.quoteState;
        return;
      }
      const base = Number(variant.price);
      const compare = Number(variant.compare_at_price) || 0;
      const discountRate = Number(block.dataset.discountRate) || 0;
      if (!Number.isFinite(base) || !Number.isFinite(compare) || base < 0) return;
      const sale = base - Math.floor(base * discountRate / 100);
      block.hidden = false;
      block.dataset.compare = compare;
      block.dataset.variantId = variant.id;
      renderPrices(block, Math.max(base, compare), sale);
      update(block);
    });
  });
  function start() {
    scan(document);
    new MutationObserver(records => records.forEach(record => {
      if (record.type === 'attributes') { if (record.target.matches('[data-card-price]')) update(record.target); }
      else record.addedNodes.forEach(node => { if (node.nodeType === 1) scan(node); });
    })).observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['data-country', 'data-currency', 'data-variant-id', 'data-compare']});
    document.addEventListener('shopify:section:load', event => scan(event.target));
    window.addEventListener('pageshow', event => {
      if (event.persisted) {
        pending.clear();
        document.querySelectorAll('[data-card-price]').forEach(block => update(block, true));
      }
    });
    window.addEventListener('online', () => document.querySelectorAll('[data-card-price][data-quote-state="unavailable"]').forEach(block => update(block, true)));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
  } catch(e) { console.error(e); }
})();

})();
